import { enqueueSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import PMBProjectSelections from 'components/PMBProjectSelections'
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from 'reactstrap'
import { useEditProjectMutation } from '../dashboardApiSlice'


const ModalEditProject = ({ isOpen, toggle, data, refetch }) => {
  const [selectedProject, setSelectedProject] = useState(null)
  const [editProject, { isLoading }] = useEditProjectMutation()

  useEffect(() => {
    if (isOpen && data) {
      if (data?.projectId && data?.projectName) {
        setSelectedProject({ id: data.projectId, label: data.projectName })
      } else {
        setSelectedProject(null)
      }
    }
  }, [isOpen, data])

  const handleSubmit = async () => {
    try {
      await editProject({
        tradeshortcutId: data?.tradeshortcutId,
        projectId: selectedProject?.id,
      }).unwrap()
      enqueueSnackbar('Project berhasil diubah', { variant: 'success' })
      refetch()
      toggle()
    } catch (error) {
      enqueueSnackbar(
        error?.data?.meta?.message ||
        error?.data?.message ||
        'Terjadi kendala',
        { variant: 'error' },
      )
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered style={{ overflow: 'visible' }} data-testid="detail-transaction-modal-edit-project">
      <ModalHeader toggle={toggle} data-testid="detail-transaction-close-button">Ubah Project</ModalHeader>
      <ModalBody style={{ overflow: 'visible' }}>
        <div>
          <label className="fw-semibold mb-1 d-block">Project </label>
          <PMBProjectSelections
            style={{ borderColor: 'white', caretColor: 'transparent' }}
            className="border-input button w-100"
            placeholder="Pilih project"
            value={selectedProject}
            onChange={(val) => setSelectedProject(val)}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          className="btn-cancel"
          outline
          onClick={toggle}
          disabled={isLoading}
          data-testid="detail-transaction-modal-edit-project-cancel"
        >
          Batal
        </Button>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={isLoading}
          data-testid="detail-transaction-modal-edit-project-submit"
        >
          {isLoading ? <Spinner size="sm" /> : 'Simpan'}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ModalEditProject
